import React from 'react';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import ClassNames from 'classnames';
import { BEM_BLOCK_NAME } from '../constants';

type PropTypes = {
    campaignName: string;
};

const useStyles = makeStyles(({ palette, spacing }) => ({
    root: {
        justifyContent: 'center',
        border: `solid 1px ${palette.border.primary}`,
        borderRadius: '24px',
        display: 'flex',
        paddingTop: spacing(2),
        paddingBottom: spacing(2),
        '& p': {
            marginBottom: 0,
            marginTop: 0,
        },
    },
    contact: {
        marginTop: spacing(1),
        textAlign: 'center',
    },
}));

function BerlinGermanGivingInstructions({ campaignName }: PropTypes) {
    const classes = useStyles();

    const rootClassNames = ClassNames(
        `${BEM_BLOCK_NAME}--giving_instructions_berlin`,
        classes.root,
    );

    return (
        <React.Fragment>
            <div className={rootClassNames}>
                <div className={`${BEM_BLOCK_NAME}--giving_instructions_berlin_inner`}>
                    <strong>Direktspenden</strong>
                    <p>Saddleback Church Berlin e.V.</p>
                    <p>IBAN: DE22 1204 0000 0624 5757 00</p>
                    <p>BIC: COBADEFFXXX (Commerzbank)</p>
                    <p>{`TAG: ${campaignName}`}</p>
                </div>
            </div>
            <div className={ClassNames(`${BEM_BLOCK_NAME}--giving_instructions_berlin_contact`, classes.contact)}>
                Für mehr Informationen kontaktiere
                {'\u00a0'}
                <a href="mailto:maripili@saddleback.de">maripili@saddleback.de</a>
            </div>
        </React.Fragment>
    );
}

export default BerlinGermanGivingInstructions;
